import { PropsWithChildren, useMemo, useState } from "react";
import { Marker } from "react-map-gl/mapbox";
import classnames from "classnames";

import styles from "./map-marker.module.css";

interface MapMarkerProps {
  latitude: number;
  longitude: number;
  active?: boolean;
  onClick?: VoidFunction;
}

const MapMarker = ({
  latitude,
  longitude,
  active,
  onClick,
  children,
}: PropsWithChildren<MapMarkerProps>) => {
  const [hovered, setHovered] = useState(false);
  const hasState = useMemo(() => {
    return active || hovered;
  }, [active]);

  return (
    <div
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      className={styles.wrapper}
    >
      <Marker latitude={latitude} longitude={longitude} onClick={onClick} anchor="bottom">
        <div
          className={classnames(styles.marker, {
            [styles.markerActive]: hasState,
          })}
        >
          {children}
        </div>
      </Marker>
    </div>
  );
};

export default MapMarker;
